import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Modal, Button, Card, Form } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import './redditionModal.scss';

export default function AddCategoryTaxesModal({ openModal, eventId, onClose, taxCategoryId, categoryTaxEdit, saveEditCategorie, saveCategorieInTree, onEditCategorieTax }) {
    const { t } = useTranslation();

    const [value, setValue] = React.useState(categoryTaxEdit?.name || '');
    const [loader, setLoader] = React.useState(false);

    return (
        <Modal
            open={Boolean(openModal)}
            onClose={onClose}
            onHide={onClose}
            size={'large'}
            title={t('ticket.tax.addTaxeCategoryModal.title')}
            submitButton={
                <Button
                    disabled={value.length === 0}
                    primary
                    onClick={() => {
                        setLoader(true);
                        if (categoryTaxEdit) {
                            onEditCategorieTax({ id_evenement: eventId, id_category: categoryTaxEdit.id_category, name: value }).then(f => {
                                setLoader(false);
                                saveEditCategorie(f, categoryTaxEdit.id_category);
                                onClose();
                            });
                        } else {
                            onEditCategorieTax({ id_evenement: eventId, taxCategoryId, name: value }).then(f => {
                                setLoader(false);
                                saveCategorieInTree(f.response);
                                onClose();
                            });
                        }
                    }}
                    label={t('ticket.common.action.add')}
                />
            }
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} />}
        >
            {loader ? (
                <Loader active inline="centered" />
            ) : (
                <Card.Content className="contentCard">
                    <Form>
                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeCategoryModal.titleInput')} />
                        <Form.Sublabel label={t('ticket.tax.addTaxeCategoryModal.subInput')}></Form.Sublabel>
                        <Form.Input autoFocus={true} value={value} onChange={event => setValue(event.target.value)} />
                    </Form>
                </Card.Content>
            )}
        </Modal>
    );
}

AddCategoryTaxesModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    eventId: PropTypes.string.isRequired,
    reloadTree: PropTypes.func.isRequired,
    saveEditCategorie: PropTypes.func.isRequired
};
